module.exports = __webpack_public_path__ + "static/media/chart-area.4dd15852.svg";